import { render, staticRenderFns } from "./feedback_config_panel.vue?vue&type=template&id=cd389ad4&scoped=true&"
import script from "./feedback_config_panel.vue?vue&type=script&lang=ts&"
export * from "./feedback_config_panel.vue?vue&type=script&lang=ts&"
import style0 from "./feedback_config_panel.vue?vue&type=style&index=0&id=cd389ad4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd389ad4",
  null
  
)

export default component.exports